class VwMbsMuhasebeislemDTO {
    id: number = null;
    organizasyonId?: number = null;
    yil?: number = null;
    yevmiyeTarihi?: string = null;
    yevmiyeNo?: number = null;
    tarih?: string = null;
    kesinlesti?: string = "H";
    fisturId?: number = null;
    carikurumId?: number = null;
    duzenlemeneden?: string = "";
    ekleri?: string = "";
    aciklama?: string = "";
    duzenleyenId?: number = null;
    imza1Id?: number = null;
    imza2Id?: number = null;
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptalTarihi?: string = null;
    iptalKullanici?: number = null;
    fkIptalneden?: number = null;
    iptalAciklama?: string = "";
    toplamBorc?: number = null;
    toplamAlacak?: number = null;
    carikurumAd?: string = "";
}
export default VwMbsMuhasebeislemDTO;